export default class Header {
    constructor($el) {
        this.$el = $el;
        this.$wrapper = document.querySelector('[data-wrapper]');

        this.$wrapper.style.setProperty('--sticky-header-height', `${this.$el.clientHeight}px`);

        this.$languageSelector = this.$el.querySelector('[data-header-language-selector]');

        if (this.$languageSelector) {
            this.languageSelectorActive = false;

            this.$languageSelectorToggle = this.$el.querySelector('[data-header-language-selector-toggle]');
            this.$languageSelectorLanguages = this.$el.querySelector('[data-header-language-selector-languages]');

            this.$languageSelectorToggle.addEventListener('click', () => {
                this.$languageSelector.classList.add('was-toggled');
                this.$languageSelector.classList.toggle('active');
                this.languageSelectorActive = ! this.languageSelectorActive;
            });

            document.addEventListener('click', (e) => {
                if ( ! this.languageSelectorActive) {
                    return;
                }

                const isClickInside = e.target.closest('[data-header-language-selector]');

                if ( ! isClickInside) {
                    this.$languageSelector.classList.remove('active');
                    this.languageSelectorActive = false;
                }
            });

            this.$languageSelector.classList.add('animate');
        }

        this.$menu = this.$el.querySelector('[data-header-menu]');
        this.$menuClose = this.$el.querySelector('[data-header-menu-close]');
        this.$menuOpen = document.querySelector('[data-header-menu-open]');
        this.$stickyFooter = document.querySelector('[data-sticky-footer-menu]');


        this.$menuOpen.addEventListener('click', (e) => {
             this.$menu.classList.add('shown');
             this.$stickyFooter.classList.add('hidden');
        });
        this.$menuClose.addEventListener('click', (e) => {
             this.$menu.classList.remove('shown');
            this.$stickyFooter.classList.remove('hidden');
        });
    }
}